import { ArrowSmRightIcon } from '@heroicons/react/solid';
import { DocLink } from './doc-link';

export function GetStarted({ doc }: any) {
  return (
    <section className="mt-10 mb-6">
      <div className="w-full px-4 mx-auto mt-5 sm:px-0 sm:flex-row sm:flex sm:justify-center md:mt-8">
        <DocLink doc={doc} />
        <div className="my-2 rounded-md sm:mx-1">
          <a
            href={`${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-up`}
            className="flex items-center justify-center px-8 py-3 text-base font-medium text-white border border-transparent rounded-md md:w-full bg-clerk-blue hover:bg-blue-700 md:py-4 md:text-lg md:px-10 btn"
          >
            Start building now
            <ArrowSmRightIcon className="w-6 h-6 ml-1 -mr-1.5" />
          </a>
        </div>
      </div>
    </section>
  );
}
